import { useState } from 'react';

import { type OpportunityStatusOldType, useOpportunityInfluenced } from '@/api/opportunity';
import { type DateRangeType, usePageFilterContext } from '@/components/page';

import OpportunityInfluenceChart from './OpportunityInfluenceChart';
import OpportunityInfluenceTable from './OpportunityInfluenceTable';

type Props = {
  opportunityType: OpportunityStatusOldType;
  isLoading?: boolean;
  audienceIds?: string[];
  campaignIds?: string[];
  vendorIds?: string[];
  pixelIds?: string[];
  canExecuteQuery?: boolean;
  groupBy?: 'CAMPAIGN' | 'VENDOR' | 'TAG';
};

const OpportunityInfluenceChartTableCombo = ({
  opportunityType,
  isLoading,
  audienceIds,
  campaignIds,
  vendorIds,
  pixelIds,
  canExecuteQuery,
  groupBy,
}: Props) => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();

  const [selectedDateRange, setSelectedDateRange] = useState<DateRangeType>();
  const audIds = audienceIds ?? (audience?.id ? [audience.id] : undefined);

  const {
    opportunityInfluenced: data,
    isLoading: isOpportunityInfluencedLoading,
    error,
  } = useOpportunityInfluenced(
    {
      startDate,
      endDate,
      campaignIds,
      vendorIds,
      pixelIds,
      audienceIds: audIds,
      groupBy,
    },
    canExecuteQuery,
  );

  return (
    <div>
      <OpportunityInfluenceChart
        opportunityType={opportunityType}
        data={data}
        isLoading={isLoading || isOpportunityInfluencedLoading}
        error={error}
        onSelectedDateRangeChange={setSelectedDateRange}
      />
      <OpportunityInfluenceTable
        opportunityType={opportunityType}
        selectedDateRange={selectedDateRange}
        isLoading={isLoading}
        campaignIds={campaignIds}
        vendorIds={vendorIds}
        pixelIds={pixelIds}
        audienceIds={audIds}
        canExecuteQuery={canExecuteQuery}
      />
    </div>
  );
};

export default OpportunityInfluenceChartTableCombo;
